import { render, staticRenderFns } from "./RepositoryCard.vue?vue&type=template&id=4c174c03&scoped=true&"
import script from "./RepositoryCard.vue?vue&type=script&lang=js&"
export * from "./RepositoryCard.vue?vue&type=script&lang=js&"
import style0 from "./RepositoryCard.vue?vue&type=style&index=0&id=4c174c03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c174c03",
  null
  
)

export default component.exports